import { render, staticRenderFns } from "./assicurazione-medico-bagaglio.vue?vue&type=template&id=5fd0f31b&scoped=true"
import script from "./assicurazione-medico-bagaglio.vue?vue&type=script&lang=js"
export * from "./assicurazione-medico-bagaglio.vue?vue&type=script&lang=js"
import style0 from "./assicurazione-medico-bagaglio.vue?vue&type=style&index=0&id=5fd0f31b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd0f31b",
  null
  
)

export default component.exports